import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

import parseJson from './utilities';

// Local SCSS.
import * as S from './styled';

/**
 * Show the provided in a pretty format.
 *
 * @param {string} json The json to show pretty.
 *
 * @return {Element} The pretty JSON.
 */
const PrettyJson = ({ json }) => (
  <S.Pre dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parseJson(json)) }} />
);

PrettyJson.propTypes = {
  json: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

export default PrettyJson;
